import { createAsyncThunk } from '@reduxjs/toolkit';
import { Referral } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindReferralSummary } from './interface';

export const findReferralSummary = createAsyncThunk(
  'referralSummary/findReferralSummary',
  async (values: FindReferralSummary, { rejectWithValue }) => {
    try {
      const response = await Referral.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
